export default __webpack_public_path__ + "static/death-vid-f9eaa4220604874ac369ed65d2c4a46f.mp4";